module.exports = __webpack_public_path__ + "static/media/ulangan.94768136.png";